// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3CtqwRV1EbV_A3DQe-yaV2","text700":"_3QwMfo0U23QQqmp1ThIdhp","text600":"_3-_iaWWhF4uIFH5G1CrTHs","text500":"_36Q2jOD7kS3N7twkxZUCG4","text400":"_24LBjYyCblu_2-Uvzu7De0","text300":"lldj7isC2O-h1Fqeklf-V","text200":"_1vyMaKmyZfvV2xlQfB8u5T","textParagraph":"_2DmXmWqd4-QPwyT0mObahV","crimp":"_2SyWx4jDlk52rMkRlkK3hx","trim":"_2WqnD5eGA7N2bE9RdakalA","flexCenter":"_215iAPGmxyrhjnid7h2B_-","hideTextOverflow":"_1e2edKCmAirjGoBWfATen6","marginPageMainContent":"_2y4q4Qg2MFHYplTNTn_V1G","scoreboardCard":"_3xxTVxPKjJoRw0Rhv3xXJg","column":"bGEwq1pazfTqRTxmL_9e5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/styles.scss
// module id = 1038
// module chunks = 0